import { render } from "./SignupHeaderBar.vue?vue&type=template&id=158da5ce&ts=true"
import script from "./SignupHeaderBar.vue?vue&type=script&lang=ts"
export * from "./SignupHeaderBar.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__